import {
  AcceptedCookiePolicyEnum,
  AcceptedCookiePolicyType,
  CookieSettingType,
  CookieTypeEnum,
} from "~/types-and-enums/cookieTypes";

export const cookieSettings = [
  {
    title: "cookieBanner.modal.functional.title",
    description: "cookieBanner.modal.functional.description",
    type: CookieTypeEnum.Functional,
    required: true,
  },
  {
    title: "cookieBanner.modal.analytics.title",
    description: "cookieBanner.modal.analytics.description",
    type: CookieTypeEnum.Analytics,
  },
  {
    title: "cookieBanner.modal.behavioral.title",
    description: "cookieBanner.modal.behavioral.description",
    type: CookieTypeEnum.Behavioral,
  },
  {
    title: "cookieBanner.modal.errorTracking.title",
    description: "cookieBanner.modal.errorTracking.description",
    type: CookieTypeEnum.ErrorTracking,
  },
] as CookieSettingType[];

export const getInitiallySelectedCookies = (
  acceptedCookiePolicy: AcceptedCookiePolicyType
) => {
  if (
    acceptedCookiePolicy === AcceptedCookiePolicyEnum.All ||
    !acceptedCookiePolicy
  ) {
    return cookieSettings.map((setting) => setting.type);
  }

  const policyCookies = acceptedCookiePolicy.split("") as CookieTypeEnum[];
  const requiredCookies = cookieSettings
    .filter((s) => s.required)
    .map((s) => s.type);

  return [...new Set([...requiredCookies, ...policyCookies])];
};
